import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import PropTypes from "prop-types";
import Card from "components/Card";

function scrollPrimaryContentToTop() {
  const region = document.getElementById("app-content-scroll");
  if (region) {
    region.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export default function ProjectFormActions({
  isFirstStep,
  isLastStep,
  isSubmitting,
  submitLabel = "Submit project",
  submittingLabel = "Submitting…",
  onCancel,
  onBack,
  onNext,
  onSubmit,
}) {
  return (
    <Card className="border-slate-200">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => {
            scrollPrimaryContentToTop();
            onCancel();
          }}
          className="text-sm font-semibold text-text-600 underline-offset-4 transition hover:text-text-900 hover:underline"
        >
          Cancel
        </button>
        <div className="ml-auto flex flex-wrap items-center justify-end gap-2">
          {isFirstStep ? null : (
            <button
              type="button"
              onClick={() => {
                scrollPrimaryContentToTop();
                onBack();
              }}
              disabled={isSubmitting}
              className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-text-800 transition hover:bg-slate-50 disabled:opacity-50"
            >
              <FiArrowLeft className="h-4 w-4" aria-hidden />
              Back
            </button>
          )}
          {isLastStep ? (
            <button
              type="button"
              onClick={() => {
                scrollPrimaryContentToTop();
                onSubmit();
              }}
              disabled={isSubmitting}
              className="inline-flex min-w-[140px] items-center justify-center rounded-lg bg-brand-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-neutral-800 disabled:opacity-50"
            >
              {isSubmitting ? (
                <span className="inline-flex items-center gap-2">
                  <span
                    className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"
                    aria-hidden
                  />
                  <span>{submittingLabel}</span>
                </span>
              ) : (
                submitLabel
              )}
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                scrollPrimaryContentToTop();
                onNext();
              }}
              disabled={isSubmitting}
              className="inline-flex items-center gap-2 rounded-lg bg-brand-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-neutral-800 disabled:opacity-50"
            >
              Next step
              <FiArrowRight className="h-4 w-4" aria-hidden />
            </button>
          )}
        </div>
      </div>
    </Card>
  );
}

ProjectFormActions.propTypes = {
  isFirstStep: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  submitLabel: PropTypes.string,
  submittingLabel: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
